var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.obnCancelBtn}},[_vm._v("放弃")]),_c('contractManagementOneCancelDialog',{attrs:{"visible":_vm.visible,"row":_vm.row},on:{"update:visible":function($event){_vm.visible=$event},"ok":_vm.ok}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }